class Slider {
    constructor(el, items, controls, count, gutter = 30) {
        this.slider = this;
        this.scope = el;
        this.items = items;
        this.count = count ? count : false;
        this.prevButton = controls[0];
        this.nextButton = controls[1];
        this.gutter = gutter;
        this.buildSlider();
        this.indexButtons();
    }

    removeFocusableItems(items) {
        items.forEach(slide => {
            const tabIndexVal = (slide.classList.contains(`tns-slide-active`)) ? "" : -1;
            slide.querySelectorAll(`a, button`).forEach(link => link.tabIndex = tabIndexVal);
        });
    }

    buildSlider() {
        let options = {
            container: this.items,
            mouseDrag: true,
            controls: true,
            loop: false,
            gutter: this.gutter,
            prevButton: this.prevButton,
            nextButton: this.nextButton,
            autoHeight: false,
            preventScrollOnTouch: false,
            onInit: () => this.removeFocusableItems(this.items.querySelectorAll(`.tns-item`)),
            responsive: {
                768: {
                    items: this.count ? this.count[0] : 2
                },
                1024: {
                    items: this.count ? this.count[1] : 3
                },
                1366: {
                    items: this.count ? this.count[2] : 3
                }
            }
        };

        this.sliderObject = tns(options);
        
        const doRemoveFocusableItems = () => this.removeFocusableItems(Array.from(this.sliderObject.getInfo().slideItems));

        this.sliderObject.events.on(`transitionStart`, doRemoveFocusableItems);

        this.resizeFunction = debounce(() => {
            this.sliderObject.updateSliderHeight();
        }, 500);

        this.sliderObject.events.on('newBreakpointEnd', doRemoveFocusableItems);

        window.addEventListener("resize", () => {
            this.resizeFunction();
        });

        this.sliderObject.events.on('indexChanged', () => {
            const slide = new CustomEvent('change', Slider.getSlideCount(this.sliderObject.getInfo()));
            this.scope.dispatchEvent(slide);
        });

        this.sliderObject.events.on("newBreakpointEnd", () => {
            const slide = new CustomEvent('change', Slider.getSlideCount(this.sliderObject.getInfo()));
            this.scope.dispatchEvent(slide);
        })

    }
        
    indexButtons() {
        if(this.prevButton){
            this.prevButton.tabIndex = 0;
            this.enterButton(this.prevButton);
        }
        if(this.nextButton){
            this.nextButton.tabIndex = 0;
            this.enterButton(this.nextButton);
        }
    }
    
    enterButton(button){
        button.addEventListener("keypress", e=>{
            if(e.code === "Enter"){
                setTimeout(()=> document.querySelector('body').classList.add('keyboard-input'), 60);
            }
        })
    }

    static getSlideCount(slider) {
        return {
            detail: {
                count: slider.slideCount,
                visible: slider.items,
                index: slider.displayIndex
            }
        };
    }

}